import { BomDto } from "src/dtos/bom/BomDto";

export interface MST1030_R01Dto extends BomDto {
    
    // MST1030에서 추가로 필요한 필드들
    itemCd: string;           // 품목코드 (childItemcd와 동일하지만 별도 관리)
    itemNm: string;           // 품목명 (childItemnm과 동일하지만 별도 관리)
    
    // 트리 구조를 위한 추가 필드들
    children?: MST1030_R01Dto[]; // 트리 구조를 위한 자식 노드들
    level?: number;              // 평면화할 때 사용할 레벨 정보
    hasChildren?: boolean;       // 원본에 자식이 있었는지 여부 (이모지 판단용)
    isExpanded?: boolean;        // 확장/축소 상태 (향후 사용)
}

/**
 * BOM 조회의 단일 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultMST1030_R01Dto: MST1030_R01Dto = {
    // BaseDto에서 상속받은 필수 필드
    valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
    prntItemcd: "",
    prntItemnm: "",
    childItemcd: "",
    childItemnm: "",
    bomUpdateNo: "",
    bomSeq: 0,
    bomUseyn: "Y",
    prntItemQty: 0,
    prntItemUnit: "",
    childItemUsage: 0,
    childItemUnit: "",
    fixLossqty: 0,
    materialIntype: "PURCHASE",
    lossPercent: 0,
    remark: "",
    itemCd: "",
    itemNm: "",
    itemSpec: "",

	inserted: false,
	isModified: false
};

/**
 * 선택된 품목 정보 타입 (검색용)
 */
export interface SelectedItemInfo {
    itemCd: string;
    itemNm: string;
}


 